import { Grid, Skeleton } from "@mui/material";
import { Line } from "components/data_display";

export default function DataFormAnotacionesClasesParticularesSkeleton() {
    return (
        <Grid container p={5}>
            <Grid item xs={12}>
                <Skeleton variant="rounded" width={"100%"} height={100} />
            </Grid>

            <Grid item xs={12} pt={5}>
                <Line />
            </Grid>

            <Grid item xs={12} pt={5}>
                <Skeleton variant="rounded" width={"100%"} height={100} />
            </Grid>
        </Grid>
    )
}